
import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'

export default function AccountTypeBasicInfoComponent ({networks,selectedAccountType,handleInnerFormChange}: any) {
  return (
    <>
 <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


      
 <InputContainer
                 label="Name"
                 labelField="Name"
                 list={networks}
                 onValueChange={(event: any) => {
                    handleInnerFormChange(
                       event.target.value,
                       'Name',
        
                     );
                 }}
                 type="select"
                 value={selectedAccountType?.Name}
                 valueField="Name"
           />
      </div>
   
  }
    expandedPanel="basicInfo"
    headerTitle="Basic Information"
/>
    
        </>
  )
}